<template>
  <div class="product-info-wrap">
    <div class="product-title">
      <span class="text">{{ productName }}</span>
      <Icon class="product-title-icon" name="history-query" />
    </div>
    <div class="product-content">{{ productDetail }}</div>
    <div class="product-btn-wrap">
      <div class="info">
        <p class="currency">{{ currency || item.GAME_CURRENCY }}</p>
        <p class="price">{{ price }}</p>
      </div>
      <div
        v-if="openShoppingCart"
        class="cart-btn flex-center"
        @click.stop="clickAddToCart"
      >
        <Icon class="cart-icon" name="shopping-cart-add" />
      </div>
      <div v-else class="cart-btn flex-center" @click.stop="selectProduct">
        <Icon class="cart-icon" name="shopping-cart-add" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';

export default {
  name: 'ProductInfo',
  mixins: [cartAddAndDetail],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    productName: {
      type: String,
      default: ''
    },
    productDetail: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      currency: state => state.showCurrency,
      openShoppingCart: state => state.page.openShoppingCart
    })
  },
  methods: {
    selectProduct() {
      this.$emit('selectProduct', this.item);
    },
    clickAddToCart() {
      this.$emit('clickAddToCart', this.item);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/officialTopup.scss';
.product-info-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
  flex: 1;

  .product-title {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 24px;
    line-height: 1.1;
    color: $commodityNameColor;
    .text {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .product-title-icon {
      flex-shrink: 0;
      margin-left: 10px;
      display: inline-block;
      width: 20px;
      height: 20px;
      color: $commodityNameColor;
    }
  }
  .product-content {
    margin-top: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 20px;
    color: $commodityDescColor;
  }
  .product-btn-wrap {
    position: relative;
    margin-top: 30px;
    width: 100%;
    height: 60px;
    border-radius: 9px;
    border: 1px solid #e8e8e8;
    line-height: 1.1;

    .info {
      margin-left: 10px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .currency {
        font-size: 16px;
        font-weight: bold;
      }
      .price {
        font-weight: bold;
        font-size: 26px;
        color: $themeColor;
      }
    }
    .cart-btn {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      min-width: 40px;
      max-width: 120px;
      text-align: center;
      padding: 0 10px;
      height: 100%;
      border-radius: 9px;
      background-color: $themeColor;
      font-size: 22px;
      color: #ffffff;
      .cart-icon {
        width: 37px;
        height: 37px;
        color: #ffffff;
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .product-info-wrap {
    .product-title {
      .product-title-icon {
        width: 23px;
        height: 23px;
      }
    }
  }
}
</style>
